import type { Slicer } from '@swf/core/store';

import type { SportsFeaturedState } from './types';

export const selectors = (slice: Slicer<SportsFeaturedState>) => ({
  menuItems: () => slice((state) => state.menuItems),
  isLoading: () => slice((state) => state.isLoading),
  errorCode: () => slice((state) => state.errorCode),
  hasPreloaded: () => slice((state) => state.preloaded)
});
